.channel-view-wrapper {
    min-height: 0;
    min-width: 0;
    flex-grow: 1;
}

.thread-content > *:not(.channel-view-wrapper) {
    flex-shrink: 0;
}
